import { useEffect, useRef, useState } from "react";
import "altcha"  ; // web component رو رجیستر می‌کنه
import {Altcha} from "altcha"
import { loadConfig } from "../utility";
const config = await loadConfig(); 

export default function AltchaCaptcha({ onVerify }) {
	const ref = useRef(null);
	const [token, setToken] = useState(null);
	 
	useEffect(() => {
		const el = ref.current;

		ref.current.strings = JSON.stringify( {
			label: "من ربات نیستم",
			verify: "تأیید",
			verified: "تأیید شد",
			verifying: "در حال تأیید...",
			error: "خطا در اعتبارسنجی",
			expired: "اعتبارسنجی منقضی شد",
			loading: "در حال بارگذاری...",
			reload: "بارگذاری مجدد",
			enterCode: "کد را وارد کنید",
			waitAlert: "در حال اعتبارسنجی، لطفاً صبر کنید"
		});
		
		const handler = (e) => {
			const payload = e.detail;
			// شامل proof + challenge + signature
			setToken(payload);
			onVerify?.(payload);
		};

		el.addEventListener("verified", handler);
		return () => el.removeEventListener("verified", handler);
	}, [onVerify]);

	return (
		<altcha-widget
			ref={ref}
			challengeurl={config.apiBaseUrl + "User/GetChallenge"}
			language="fa"
			hidelogo
			hidefooter
		/>
	);
}
